export { default } from './Layout';

require('./layout.scss');